{
  "version": 1,
  "asset_id": "d866f0c1-2bf1-4c7c-a762-41386972d2b2",
  "project_id": "f4a4cb9e-10ac-4832-a8e3-d05c1765811e",
  "url": "/__l5e/assets-v1/d866f0c1-2bf1-4c7c-a762-41386972d2b2/jaik-home-hero.webm",
  "r2_key": "a/v1/f4a4cb9e-10ac-4832-a8e3-d05c1765811e/d866f0c1-2bf1-4c7c-a762-41386972d2b2/jaik-home-hero.webm",
  "original_filename": "jaik-home-hero.webm",
  "size": 8558034,
  "content_type": "video/webm",
  "created_at": "2026-09-10T04:09:28Z"
}
